import { ShouldRenderTabsService } from '@philips-emr/hpms-provider-commons';
import { TabControlAPI, TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import { AccreditationBedsAndEquipmentsAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

enum BedsAndEquipmentsType {
  BEDS = 'beds',
  EQUIPMENTS = 'equipments',
}

@Controller({ fragment: FragmentNames.ACCREDITATION_BEDS_AND_EQUIPMENTS })
class AccreditatonBedsAndEquipmentsController extends BaseController {

  @OnMount(Aliases.TAB_CONTROL)
  onMountTabControl(event: MountEvent): void {
    const { nrSeqUser, nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqUser, nrSeqAccreditation });
    const api = event.target as TabControlAPI;
    ShouldRenderTabsService.chooseDefaultTab(api, [BedsAndEquipmentsType.BEDS, BedsAndEquipmentsType.EQUIPMENTS]);
  }

  @OnMount(Aliases.TAB_WITH_CONTENT_BEDS)
  onMountBeds(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, BedsAndEquipmentsType.BEDS);
  }

  @OnMount(Aliases.TAB_WITH_CONTENT_EQUIP)
  onMountEquipTab(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, BedsAndEquipmentsType.EQUIPMENTS);
  }
}

export {
  AccreditatonBedsAndEquipmentsController,
};
